export default "__VITE_ASSET__B6vZ84Fn__"